import "./NavigationSkeletonLoader.scss";

export const NavigationSkeletonLoader = () => {
  return (
    <>
      <div className="NavigationSkeletonLoader__item" />
      <div className="NavigationSkeletonLoader__item" />
      <div className="NavigationSkeletonLoader__item" />
      <div className="NavigationSkeletonLoader__item" />
    </>
  );
};
